import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Base Approvable records use this schema; polymorphic linkage supplies concrete types for the type: '' targets.
const ApprovableSchema = withDefaults({
  type: 'approvable',
  fields: [
    { kind: 'attribute', name: 'approval' },
    { kind: 'attribute', name: 'state' },
    { kind: 'attribute', name: 'transitionLog' },
    { kind: 'attribute', name: 'affirmed' },
    { kind: 'attribute', name: 'currentReviewers' },
    { kind: 'attribute', name: 'possibleReviewers' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    { kind: 'attribute', name: 'createdBy' },
    { kind: 'attribute', name: 'updatedBy' },
    { kind: 'attribute', name: 'dataState' },
    { kind: 'attribute', name: 'dataStateLog' },
    { kind: 'attribute', name: 'deletedAt' },
    {
      kind: 'belongsTo',
      name: 'approvable',
      type: '',
      options: { async: false, inverse: null, polymorphic: true },
    },
    {
      kind: 'belongsTo',
      name: 'inContext',
      type: '',
      options: { async: false, inverse: null, polymorphic: true },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: { async: false, inverse: null },
    },
    { kind: 'belongsTo', name: 'person', type: 'person', options: { async: false, inverse: null } },
  ],
});

export default ApprovableSchema;
